import { FCX } from "@datassential/platform-ui-lib";
import TopFoodBeveragePosts from "@components/TopFoodBeveragePosts/TopFoodBeveragePosts";
import { useTopFoodBeveragePosts } from "@apiHooks/useTopFoodBeveragePosts";
import './TrendingNowSocialPosts.scss';

const TrendingNowSocialPosts: FCX = () => {
    const { data, isLoading } = useTopFoodBeveragePosts();

    return (
        <TopFoodBeveragePosts
            className="TrendingNowSocialPosts"
            data={data}
            isLoading={isLoading}
            showFollowers
        />
    );
};

export default TrendingNowSocialPosts;
